import React from "react";
import { useI18n } from "@/lib/i18n";
import { Facebook, Instagram, Linkedin, Twitter, Mail, Phone, MessageCircle, Globe } from "lucide-react";

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "https://facebook.com/agrinova.one", testid: "social-facebook" },
  { icon: Instagram, label: "Instagram", href: "https://instagram.com/agrinova.one", testid: "social-instagram" },
  { icon: Linkedin, label: "LinkedIn", href: "https://linkedin.com/company/agrinova.one", testid: "social-linkedin" },
  { icon: Twitter, label: "X (Twitter)", href: "https://x.com/agrinova.one", testid: "social-x" },
];

export default function ContactFooter() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-border bg-secondary/60" data-testid="contact-footer">
      <div className="max-w-6xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="space-y-3">
          <div className="flex items-center gap-3">
            <img src="/logo-agrinova.png" alt="AgriNova" className="w-10 h-10 rounded-lg object-cover" />
            <div>
              <div className="font-bold">AgriNova</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{t("slogan")}</div>
            </div>
          </div>
          <div className="label-eyebrow">{t("follow_us")}</div>
          <div className="flex gap-2">
            {SOCIALS.map(({ icon: Icon, label, href, testid }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} data-testid={testid}
                className="w-9 h-9 rounded-lg border border-border bg-card flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/50 transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div className="space-y-2.5 text-sm">
          <div className="label-eyebrow mb-2">Contact</div>
          <a href="mailto:contact@agrinova.one" data-testid="contact-email" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors">
            <Mail className="w-4 h-4 shrink-0" /> contact@agrinova.one
          </a>
          <a href="tel:+33652516105" data-testid="contact-phone-fr" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors">
            <Phone className="w-4 h-4 shrink-0" /> +33 6 52 51 61 05
          </a>
          <a href="tel:+237678306250" data-testid="contact-phone-cm" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors">
            <Phone className="w-4 h-4 shrink-0" /> +237 678 30 62 50
          </a>
          <a href="https://wa.me/33652516105" target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors">
            <MessageCircle className="w-4 h-4 shrink-0" /> WhatsApp
          </a>
        </div>
        <div className="space-y-2.5 text-sm">
          <div className="label-eyebrow mb-2">{t("website")}</div>
          <a href="https://www.agrinova.one" target="_blank" rel="noopener noreferrer" data-testid="contact-website" className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors">
            <Globe className="w-4 h-4 shrink-0" /> www.agrinova.one
          </a>
        </div>
      </div>
      <div className="border-t border-border py-4 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} AgriNova — {t("slogan")}
      </div>
    </footer>
  );
}
